// Compatibility shim (Wave 1 · P1). The application logger now lives in
// `@heidi/runtime/logger`; this runtime re-export keeps the ~833 existing
// `@/utils/logger/logger` importers — and the global + per-suite
// `jest.mock('@/utils/logger/logger', …)` sites — compiling unchanged.
// Burned down by the deferred consumer codemod.
export { logger } from '@heidi/runtime/logger';
